const typography = {
  fontFamily: ['Roboto', 'sans-serif'].join(','),

  fontSize: 13.125,
  h1: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: '30.8px',
    letterSpacing: '0.005em',
    '@media (max-width:768px)': {
      fontSize: 26,
      lineHeight: '28.4px'
    }
  },
  h2: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '26.4px',
    letterSpacing: '0.0025em',
    '@media (max-width:768px)': {
      fontSize: 22,
      lineHeight: '24.4px'
    }
  },
  h3: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '22.6px',
    letterSpacing: '0.0025em',
    '@media (max-width:768px)': {
      fontSize: 18,
      lineHeight: '22.4px'
    }
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.364,
    fontSize: '1.375rem'
  },
  h5: {
    fontWeight: 500,
    lineHeight: 1.3334,
    fontSize: '1.125rem'
  },
  h6: {
    lineHeight: 1.4,
    fontSize: '0.9375rem'
  },
  subtitle1: {
    fontSize: '1rem',
    letterSpacing: '0.15px'
  },
  subtitle2: {
    lineHeight: 1.32,
    fontSize: '0.875rem',
    letterSpacing: '0.1px'
  },
  label: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '21.6px',
    letterSpacing: '0.0025em'
  },
  body1: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '20.8px',
    letterSpacing: '0.0025em',
    '@media (max-width:768px)': {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '20.8px'
    }
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18.2px',
    letterSpacing: '0.0025em',
    '@media (max-width:768px)': {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '18.2px'
    }
  },
  button: {
    lineHeight: 1.2,
    fontSize: '0.9375rem',
    letterSpacing: '0.43px'
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '15.6px',
    letterSpacing: '0.0025em'
  },
  overline: {
    fontSize: '0.75rem',
    letterSpacing: '1px'
  },
  a: {
    fontSize: '19px !important'
  }
}

export default typography
